// Connections & vault (contracts.md:46-48,53). POST /v1/connections/install-url starts
// the GitHostClient/CloudFederationClient redirect handoff (screens 3/4);
// GET /v1/connections lists rows for screen 8; revoke/restore and the banner read
// model round out D49.
import { z } from "zod";
import { AppId, Connection, ConnectionId, NonEmptyString, RepoHost } from "@nightcrew/shared";
import { BannerState } from "@nightcrew/shared";
import type { Result } from "@nightcrew/shared";
import { apiFetch, apiPost } from "./client.js";
import type { ClientError } from "./errors.js";

// RECONCILED at Wave-3 integration: install-url binds the state to an app (the callback
// fingerprints THAT app), so the api requires appId alongside host.
export const InstallUrlRequest = z.object({ host: RepoHost, appId: AppId });
export type InstallUrlRequest = z.infer<typeof InstallUrlRequest>;

export const InstallUrlResponse = z.object({ url: NonEmptyString, state: NonEmptyString });
export type InstallUrlResponse = z.infer<typeof InstallUrlResponse>;

export const getInstallUrl = (
  request: InstallUrlRequest,
): Promise<Result<InstallUrlResponse, ClientError>> =>
  apiPost("/v1/connections/install-url", InstallUrlResponse, request);

/** ASSUMPTION (no cited wire schema for the list envelope): `{connections: Connection[]}`,
 * matching this lane's AppList envelope shape (src/api/apps.ts). */
export const ConnectionList = z.object({ connections: z.array(Connection) });
export type ConnectionList = z.infer<typeof ConnectionList>;

export const listConnections = (): Promise<Result<ConnectionList, ClientError>> =>
  apiFetch("/v1/connections", ConnectionList);

export const getConnectionBanner = (): Promise<Result<BannerState, ClientError>> =>
  apiFetch("/v1/connections/banner", BannerState);

export const revokeConnection = (
  connectionId: ConnectionId,
): Promise<Result<Connection, ClientError>> =>
  apiPost(`/v1/connections/${connectionId}/revoke`, Connection, {});

export const restoreConnection = (
  connectionId: ConnectionId,
): Promise<Result<Connection, ClientError>> =>
  apiPost(`/v1/connections/${connectionId}/restore`, Connection, {});
